const endPoint = process.env.REACT_APP_backend || "http://localhost:1555";

export async function getTest(testId) {
	const response = await fetch(endPoint + "/" + testId );
	return response.json();
}